import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The design system replaces Tailwind's default font-size scale with a NAMED
 * scale (see tailwind.config.ts). tailwind-merge does not know these tokens, so
 * without registering them it treats e.g. `text-body` and `text-accent` as the
 * same `text-*` group and silently drops the color. Register the size tokens in
 * the `font-size` group so size and color coexist correctly.
 *
 * When a NEW named size token is added to the type scale, add it here too.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: ['caption', 'small', 'row', 'body', 'h2', 'stat'],
        },
      ],
    },
  },
});

/** Merge conditional class names with Tailwind conflict resolution. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
